import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/normal-activity/List.vue')

const Preview = () => import('../views/normal-activity/Preview.vue')

const Stat = () => import('../views/normal-activity/Stat.vue')
const SchoolUniformSetting = () => import('../views/normal-activity/SchoolUniformSetting.vue')

const CreateStart = () => import('../views/normal-activity/Step0.vue')
const CreateStep1 = () => import('../views/normal-activity/Step1.vue')
const CreateStep2 = () => import('../views/normal-activity/Step2.vue')

const CreateStep = () => import('../views/normal-activity/Step.vue')

const DetailOfPELessons = () => import('../views/normal-activity/DetailOfPELessons.vue')

const DetailOfQAOrSkills = () => import('../views/normal-activity/DetailOfQAOrSkills.vue')

const DetailOfRunTask = () => import('../views/normal-activity/DetailOfRunTask.vue')

const DetailOfTestStandard = () => import('../views/normal-activity/DetailOfTestStandard.vue')

const DeliveryAddressEdit = () => import('../views/normal-activity/DeliveryAddressEdit.vue')

const Landing2023Winter = () => import('../views/normal-activity/Landing2023Winter.vue')

const Landing2023Spring = () => import('../views/normal-activity/Landing2023Spring.vue')

const Landing2023Summer = () => import('../views/normal-activity/Landing2023Summer.vue')

const Poster2023Winter = () => import('../views/normal-activity/Poster2023Winter.vue')

const Poster2024Winter = () => import('../views/normal-activity/Poster2024Winter.vue')

const PosterDefault = () => import('../views/normal-activity/PosterDefault.vue')

const Poster2023Spring = () => import('../views/normal-activity/Poster2023Spring.vue')

const Poster2023Summer = () => import('../views/normal-activity/Poster2023Summer.vue')

const QuizStatClazz = () => import('../views/normal-activity/quiz-stat/ClazzList.vue')
const QuizStatClazzStudent = () => import('../views/normal-activity/quiz-stat/ClazzStudentList.vue')
const QuizStatStudentQuizList = () => import('../views/normal-activity/quiz-stat/StudentQuizList.vue')

export const listRoute: RouteConfig = {
  path: '/normal-activity-list',
  name: 'normal_activity_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业列表',
  },
}

export const statRoute: RouteConfig = {
  path: '/normal-activity-stat',
  name: 'normal_activity_stat',
  component: Stat,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '数据统计',
  },
}

export const previewRoute: RouteConfig = {
  path: '/normal-activity-preview',
  name: 'normal_activity_preview',
  component: Preview,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业详情',
  },
}

export const createStartRoute: RouteConfig = {
  path: '/normal-activity-start',
  name: 'normal_activity_start',
  component: CreateStart,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置作业',
  },
}

export const createStep1Route: RouteConfig = {
  path: '/normal-activity-step1',
  name: 'normal_activity_step1',
  component: CreateStep1,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置作业',
  },
}

export const createStep2Route: RouteConfig = {
  path: '/normal-activity-step2',
  name: 'normal_activity_step2',
  component: CreateStep2,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置作业',
    keepAlive: true,
  },
}

export const createStepRoute: RouteConfig = {
  path: '/normal-activity-step',
  name: 'normal_activity_step',
  component: CreateStep,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '布置作业',
  },
}

export const detailOfPELessonsRoute: RouteConfig = {
  path: '/normal-activity-detail-PElesson',
  name: 'normal_activity_detail_PElesson',
  component: DetailOfPELessons,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNos: JSON.parse(route.query.gradeNos as string),
    startTime: JSON.parse(route.query.startTime as string),
    endTime: JSON.parse(route.query.endTime as string),
  }),
  meta: {
    title: '体育作业详情',
  },
}

export const detailOfQAOrSkillsRoute: RouteConfig = {
  path: '/normal-activity-detail-QA-or-skills',
  name: 'normal_activity_detail_QA_or_skills',
  component: DetailOfQAOrSkills,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNos: JSON.parse(route.query.gradeNos as string),
  }),
}

export const detailOfRunTaskRoute: RouteConfig = {
  path: '/normal-activity-detail-RunTask',
  name: 'normal_activity_detail_RunTask',
  component: DetailOfRunTask,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNos: JSON.parse(route.query.gradeNos as string),
  }),
  meta: {
    title: '运动任务',
  },
}

export const detailOfTestStandardRoute: RouteConfig = {
  path: '/normal-activity-detail-TestStandard',
  name: 'normal_activity_detail_TestStandard',
  component: DetailOfTestStandard,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNos: JSON.parse(route.query.gradeNos as string),
    startTime: JSON.parse(route.query.startTime as string),
    endTime: JSON.parse(route.query.endTime as string),
  }),
  meta: {
    title: '达标任务',
  },
}

export const winter2023LandingRoute: RouteConfig = {
  path: '/normal-activity-winter-2023-landing',
  name: 'normal_activity_winter_2023_landing',
  component: Landing2023Winter,
  props: (route) => ({ ...route.query, ...route.params, qd: route.query.qd }),
  meta: {
    title: '寒假体育作业',
  },
}

export const spring2023LandingRoute: RouteConfig = {
  path: '/normal-activity-spring-2023-landing',
  name: 'normal_activity_spring_2023_landing',
  component: Landing2023Spring,
  props: (route) => ({ ...route.query, ...route.params, qd: route.query.qd }),
  meta: {
    title: '新学期体育作业',
  },
}

export const summer2023LandingRoute: RouteConfig = {
  path: '/normal-activity-summer-2023-landing',
  name: 'normal_activity_summer_2023_landing',
  component: Landing2023Summer,
  props: (route) => ({ ...route.query, ...route.params, qd: route.query.qd }),
  meta: {
    title: '暑假体育作业',
    ignoreLogin: true,
  },
}

export const winter2023PosterRoute: RouteConfig = {
  path: '/normal-activity-winter-2023-poster',
  name: 'normal_activity_winter_2023_poster',
  component: Poster2023Winter,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分享海报',
  },
}

export const spring2023PosterRoute: RouteConfig = {
  path: '/normal-activity-spring-2023-poster',
  name: 'normal_activity_spring_2023_poster',
  component: Poster2023Spring,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分享海报',
  },
}

export const summer2023PosterRoute: RouteConfig = {
  path: '/normal-activity-summer-2023-poster',
  name: 'normal_activity_summer_2023_poster',
  component: Poster2023Summer,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分享海报',
  },
}

export const winter2024PosterRoute: RouteConfig = {
  path: '/normal-activity-winter-2024-poster',
  name: 'normal_activity_winter_2024_poster',
  component: Poster2024Winter,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分享海报',
  },
}

export const defaultPosterRoute: RouteConfig = {
  path: '/normal-activity-default-poster',
  name: 'normal_activity_default_poster',
  component: PosterDefault,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分享海报',
  },
}

export const deliveryAddressEditRoute: RouteConfig = {
  path: '/normal-activity-delivery-address-edit',
  name: 'normal_activity_delivery_address_edit',
  component: DeliveryAddressEdit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '填写收货地址',
  },
}

export const schoolUniformSettingRoute: RouteConfig = {
  path: '/normal-activity-school-uniform-setting',
  name: 'normal_activity_school_uniform_setting',
  component: SchoolUniformSetting,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '定制暑假奖品',
  },
}

// ======= 活动中quiz的统计路由
export const quizStatClazzListRoute: RouteConfig = {
  path: '/normal-activity-quiz-stat-clazz',
  name: 'normal_activity_quiz_stat_clazz',
  component: QuizStatClazz,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '答题表现',
  },
}

export const quizStatClazzStudentListRoute: RouteConfig = {
  path: '/normal-activity-quiz-stat-student',
  name: 'normal_activity_quiz_stat_student',
  component: QuizStatClazzStudent,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '答题表现',
  },
}

export const quizStatStudentQuizListRoute: RouteConfig = {
  path: '/normal-activity-quiz-stat-student-quiz',
  name: 'normal_activity_quiz_stat_student_quiz',
  component: QuizStatStudentQuizList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生答题详情',
  },
}

export default [
  listRoute,
  previewRoute,
  statRoute,
  createStartRoute,
  createStep1Route,
  createStep2Route,
  createStepRoute,
  detailOfPELessonsRoute,
  detailOfQAOrSkillsRoute,
  detailOfRunTaskRoute,
  detailOfTestStandardRoute,
  deliveryAddressEditRoute,
  winter2023LandingRoute,
  spring2023LandingRoute,
  summer2023LandingRoute,
  winter2023PosterRoute,
  spring2023PosterRoute,
  summer2023PosterRoute,
  winter2024PosterRoute,
  schoolUniformSettingRoute,
  defaultPosterRoute,
  quizStatClazzListRoute,
  quizStatClazzStudentListRoute,
  quizStatStudentQuizListRoute,
]

// 活动默认poster，给定活动id, 否则用默认
export function navigateToActivityPoster(router: VueRouter, activityId?: string) {
  router.push({ name: defaultPosterRoute.name, query: { activityId: activityId || '' } })
}
